var map = {
	"./admin.js": "ce1a",
	"./auth.js": "831c",
	"./availability.js": "cabf",
	"./ehr.js": "4c62",
	"./errors.js": "092f",
	"./image.js": "042f",
	"./index.js": "32bb",
	"./network.js": "cda2",
	"./patient-review.js": "5bcc",
	"./patients.js": "d561",
	"./practice.js": "af2d",
	"./profile.js": "5eaf",
	"./public.js": "1100",
	"./referrals-pool.js": "44f0",
	"./referrals.js": "78b1",
	"./temporary-referrals.js": "1dbd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f1f7";